import React, { createContext, useState, useEffect } from "react";
import all_product from "../Components/Assets/all_product";

export const ShopContext = createContext(null);

const getDefaultCart = () => {
  let cart = {};
  for (let index = 0; index < all_product.length+1; index++) {
    cart[index] = 0;
  }
  return cart;
};

const ShopContextProvider = (props) => {

  const [cartItems, setCartItems] = useState(getDefaultCart());
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check for existing user session on app load
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error parsing saved user data:', error);
        localStorage.removeItem('user');
      }
    }
  }, []);

  // User authentication functions
  const signup = (name, email, password) => {
    // In a real app, this would make an API call
    // For now, we'll simulate user creation
    const newUser = {
      id: Date.now(),
      name,
      email,
      password, // In production, this should be hashed
      createdAt: new Date().toISOString()
    };
    
    // Check if user already exists
    const existingUsers = JSON.parse(localStorage.getItem('users') || '[]');
    const userExists = existingUsers.find(u => u.email === email);
    
    if (userExists) {
      throw new Error('User with this email already exists');
    }
    
    // Save new user
    existingUsers.push(newUser);
    localStorage.setItem('users', JSON.stringify(existingUsers));
    
    // Auto-login after signup
    login(email, password);
    
    return newUser;
  };

  const login = (email, password) => {
    // In a real app, this would make an API call
    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const user = users.find(u => u.email === email && u.password === password);
    
    if (!user) {
      throw new Error('Invalid email or password');
    }
    
    // Remove password from user object before storing in state
    const { password: _, ...userWithoutPassword } = user;
    
    setUser(userWithoutPassword);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userWithoutPassword));
    
    return userWithoutPassword;
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
    // Clear cart on logout
    setCartItems(getDefaultCart());
  };

  const updateUserProfile = (updates) => {
    if (!user) return;
    
    const updatedUser = { ...user, ...updates };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    
    // Update in users array
    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const userIndex = users.findIndex(u => u.id === user.id);
    if (userIndex !== -1) {
      users[userIndex] = { ...users[userIndex], ...updates };
      localStorage.setItem('users', JSON.stringify(users));
    }
  };


  const addToCart = (itemId) => {
    setCartItems((prev) =>( {...prev,[itemId]:prev[itemId] +1}))
    console.log(cartItems)
  } 

  const removeFromCart = (itemId) => {
    setCartItems((prev) =>( {...prev,[itemId]:prev[itemId] -1}))
  } 


  const getTotalCartAmount = () =>{
    let totalAmount = 0;
    for(const item in cartItems){
      if(cartItems[item] > 0 ){

        let itemInfo = all_product.find((product)=> product.id===Number(item) )
        totalAmount += itemInfo.new_price * cartItems[item]
      }
      
    }
    return totalAmount
  }

  const getTotalCartItems = () =>{
    let totalItem = 0;
    for(const item in cartItems){
      if(cartItems[item]> 0){
        totalItem += cartItems[item]
      }
    }
    return totalItem
  }


  const contextValue = {
    getTotalCartItems, 
    getTotalCartAmount, 
    all_product, 
    cartItems, 
    addToCart, 
    removeFromCart,
    user,
    isAuthenticated,
    signup,
    login,
    logout,
    updateUserProfile
  };
  
  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
